import { ShoesState } from 'src/types'

export const resinSoleEvaWhiteCleats = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'

  ctx.lineWidth = 1.0

  ctx.fillStyle = 'white'
  ctx.beginPath()
  ctx.moveTo(395, 499) // 左下
  ctx.quadraticCurveTo(463, 481, 569, 485)
  ctx.quadraticCurveTo(629, 486, 739, 475)
  ctx.quadraticCurveTo(799, 490, 849, 486) // 右下
  ctx.quadraticCurveTo(860, 482, 853, 473)
  ctx.quadraticCurveTo(832, 473, 821, 467)
  ctx.quadraticCurveTo(802, 463, 788, 464)
  ctx.quadraticCurveTo(750, 456, 750, 456)
  ctx.quadraticCurveTo(723, 452, 687, 460)
  ctx.quadraticCurveTo(605, 467, 555, 465)
  ctx.quadraticCurveTo(451, 468, 405, 483)
  // ctx.quadraticCurveTo(
  // ctx.quadraticCurveTo(
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.fillStyle = '#bfbfbf'
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(16, 433) //つま先＿左下
  ctx.quadraticCurveTo(78, 472, 175, 496)
  ctx.quadraticCurveTo(247, 514, 311, 510)
  ctx.quadraticCurveTo(356, 505, 417, 496)
  ctx.quadraticCurveTo(452, 480, 549, 484)
  ctx.quadraticCurveTo(653, 489, 740, 474)
  ctx.quadraticCurveTo(812, 493, 849, 482)
  ctx.quadraticCurveTo(845, 510, 801, 517)
  ctx.quadraticCurveTo(757, 523, 757, 521)
  ctx.quadraticCurveTo(749, 538, 749, 538) // かかと歯の右上
  ctx.quadraticCurveTo(715, 541, 715, 541)
  ctx.quadraticCurveTo(673, 529, 673, 529)
  ctx.quadraticCurveTo(672, 524, 672, 524)
  ctx.quadraticCurveTo(597, 518, 537, 503)
  ctx.quadraticCurveTo(484, 495, 452, 503)
  ctx.quadraticCurveTo(419, 514, 375, 514)
  ctx.quadraticCurveTo(348, 517, 348, 517)
  ctx.quadraticCurveTo(243, 525, 162, 502)
  ctx.quadraticCurveTo(60, 475, 20, 445)
  ctx.quadraticCurveTo(13, 440, 16, 433)
  // ctx.quadraticCurveTo(
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 歯_先頭1
  ctx.fillStyle = '#44463F'
  ctx.beginPath()
  ctx.moveTo(81, 478) //つま先＿左下
  ctx.quadraticCurveTo(76, 495, 76, 497)
  ctx.quadraticCurveTo(90, 499, 96, 484)
  ctx.quadraticCurveTo(81, 478, 81, 478)
  // ctx.quadraticCurveTo(
  ctx.stroke()
  ctx.fill()
  ctx.closePath()

  // 歯_先頭2
  ctx.fillStyle = '#44463F'
  ctx.beginPath()
  ctx.moveTo(151, 512) //つま先＿左下
  ctx.quadraticCurveTo(148, 528, 148, 528)
  ctx.quadraticCurveTo(148, 531, 153, 536)
  ctx.quadraticCurveTo(159, 542, 165, 531)
  ctx.quadraticCurveTo(169, 516, 169, 516)
  ctx.quadraticCurveTo(151, 512, 151, 512)
  // ctx.quadraticCurveTo(
  ctx.stroke()
  ctx.fill()
  ctx.closePath()
  // 歯_先頭2の接続
  ctx.fillStyle = '#bfbfbf'
  ctx.beginPath()
  ctx.moveTo(148, 499) //つま先＿左下
  ctx.quadraticCurveTo(148, 505, 148, 505)
  ctx.quadraticCurveTo(147, 511, 166, 516)
  ctx.quadraticCurveTo(215, 515, 215, 515)
  // ctx.quadraticCurveTo(
  ctx.fill()
  ctx.moveTo(148, 506)
  ctx.quadraticCurveTo(166, 514, 166, 514)
  ctx.quadraticCurveTo(178, 515, 178, 515)
  // ctx.quadraticCurveTo(
  ctx.stroke()
  ctx.closePath()

  // 歯_先頭3
  ctx.fillStyle = '#44463F'
  ctx.beginPath()
  ctx.moveTo(292, 530) //つま先＿左下
  ctx.quadraticCurveTo(292, 547, 292, 547)
  ctx.quadraticCurveTo(294, 558, 301, 557)
  ctx.quadraticCurveTo(309, 562, 313, 553)
  ctx.quadraticCurveTo(317, 549, 317, 557)
  ctx.quadraticCurveTo(328, 557, 332, 550)
  ctx.quadraticCurveTo(333, 530, 333, 530)
  ctx.quadraticCurveTo(292, 530, 292, 530)
  // ctx.quadraticCurveTo(
  ctx.stroke()
  ctx.fill()
  ctx.closePath()

  // 歯_先頭3の接続パーツ
  ctx.fillStyle = '#bfbfbf'
  ctx.beginPath()
  ctx.moveTo(270, 519) //つま先＿左下
  ctx.quadraticCurveTo(282, 530, 282, 530)
  ctx.quadraticCurveTo(315, 534, 342, 528)
  ctx.quadraticCurveTo(349, 517, 349, 517)
  ctx.quadraticCurveTo(270, 519, 270, 519)
  // ctx.quadraticCurveTo(
  ctx.fill()
  ctx.moveTo(280, 527)
  ctx.quadraticCurveTo(315, 530, 343, 524)
  // ctx.quadraticCurveTo(
  ctx.stroke()
  ctx.closePath()

  // 歯_先頭3
  ctx.fillStyle = '#44463F'
  ctx.beginPath()
  ctx.moveTo(719, 542) //つま先＿左下
  ctx.quadraticCurveTo(719, 558, 719, 560)
  ctx.quadraticCurveTo(731, 574, 738, 562)
  ctx.quadraticCurveTo(738, 558, 741, 563)
  ctx.quadraticCurveTo(742, 569, 738, 565)
  ctx.quadraticCurveTo(745, 568, 745, 560)
  ctx.quadraticCurveTo(744, 539, 744, 539)
  ctx.quadraticCurveTo(719, 542, 719, 542)
  // ctx.quadraticCurveTo(
  ctx.stroke()
  ctx.fill()
  ctx.closePath()

  // デザインライン
  ctx.lineWidth = 2.0
  ctx.beginPath()
  ctx.moveTo(348, 515)
  ctx.quadraticCurveTo(369, 517, 381, 511)
  ctx.quadraticCurveTo(466, 483, 562, 502)
  ctx.quadraticCurveTo(614, 513, 677, 517)
  // ctx.quadraticCurveTo(
  ctx.stroke()
  ctx.lineWidth = 1.0
  ctx.moveTo(718, 499)
  ctx.quadraticCurveTo(715, 539, 715, 539)
  ctx.moveTo(719, 496)
  ctx.quadraticCurveTo(707, 511, 682, 517)
  // ctx.quadraticCurveTo(
  ctx.moveTo(719, 496)
  ctx.quadraticCurveTo(739, 516, 754, 520)
  // ctx.quadraticCurveTo(
  ctx.stroke()
  ctx.closePath()

  ctx.lineWidth = 1.0

  // ctx.beginPath()
  // ctx.moveTo(16, 433) //つま先＿左下
  // // ctx.quadraticCurveTo(
  //   ctx.stroke()
  //   ctx.closePath()
}
